/** 分页组件配置列表 */
export const PAGE_PROPS: (
    | 'current'
    | 'defaultCurrent'
    | 'disabled'
    | 'defaultPageSize'
    | 'pageSize'
    | 'pageSizeOptions'
    | 'hideOnSinglePage'
    | 'showPrevNextJumpers'
    | 'showLessItems'
    | 'showTitle'
    | 'onShowSizeChange'
    | 'itemRender'
    | 'simple'
)[] = [
    'current',
    'defaultCurrent',
    'disabled',
    'defaultPageSize',
    'pageSize',
    'pageSizeOptions',
    'hideOnSinglePage',
    'showPrevNextJumpers',
    'showLessItems',
    'showTitle',
    'onShowSizeChange',
    'itemRender',
    'simple',
];
